import React, { useContext } from 'react';
import { Context } from '../../../config/store';
function subtractMonths(date, months) {
	date.setMonth(date.getMonth() - months);
	return date;
}
const LeadType = ({ row, _field }) => {
	
	const { state } = useContext(Context);
	if (state.userType === 'lender')
		return (
			<span>Option {row?.assigned_lenders?.[0]?.lead_assign_as_type}</span>
		);
	else {
		if (row.lead_type === 1 && row.application_status === 'Pre-Sanctioned') {
			return <span>{row.is_da === 1 ? 'DA' : `Option ${row.lead_type}`}</span>
		} else {
			return <span>{row.is_da === 1 ? 'DA' : `Option ${row.lead_type}`}</span>
		}
	}
};

export default LeadType;
